"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signDataMobile = exports.generateKeyPairMobile = void 0;
const react_native_rsa_native_1 = require("react-native-rsa-native");
const md5 = require('md5');
const react_native_base64_1 = __importDefault(require("react-native-base64"));
const generateKeyPairMobile = async () => {
    return await react_native_rsa_native_1.RSAKeychain.generate('com.qvistorp.flyway');
};
exports.generateKeyPairMobile = generateKeyPairMobile;
const signDataMobile = async (data) => {
    const jsonString = JSON.stringify(data).replace(/["',.\s]/g, '');
    const dataBuffer = md5(jsonString);
    let signature = await react_native_rsa_native_1.RSAKeychain.sign(dataBuffer, 'com.qvistorp.flyway');
    return {
        ...data,
        signature: signature,
        validation: react_native_base64_1.default.encode(globalThis.mobile_public_key)
    };
};
exports.signDataMobile = signDataMobile;
